import { render } from "./Wheel6.vue?vue&type=template&id=3e89d384"
const script = {}
script.render = render

export default script